<template>
	<div class="vsebina ">

  <div class="glava_vsebine adapt v-adapt">

	<div class="cols">
	<div class="col left grid-col-6">
	  <h1>Zapisnik EKO</h1>
	</div>
	
	
	
	<div class="col right">
	</div>
	
	</div>
  </div>
  
  <div class="telo_vsebine adapt v-adapt">
<div v-if="!pridelovalecid">
  NI PODATKOV
</div>
<div v-else>
<div>
	  <div :style="{ display: 'inline-block' }">
			  <pridelovalec :pridelovalec="pridelovalec" shema="IP" :sezona="dataSezona.sezona" 
			  :kontrolaid="kontrolaid"
                    :podshema="kontrola.podrocjecertificiranja">
		</pridelovalec>
		  
		</div>
	  </div>
<div class="uporabnik-spacer" style="margin-top:2rem"></div>
<div class="">
<form @submit.prevent="handleSubmit" class="k-form">

	<div class="form-group">
		<div class="km-widget km-buttongroup k-widget k-button-group">
			<button class="k-button k-primary" :disabled="kontrola.status=='konec'||kontrola.status=='odločitev'||kontrola.status=='pregled'" @click="shraniKontrole" >Shrani</button>
			<button class="k-button k-primary" :disabled="pridelovalec.pisanje==0" @click="izdelajZapisnik" >Izdelaj zapisnik</button>
			<button class="k-button k-primary" @click="nazaj" >Nazaj</button>
		</div>
    </div>

		
	<div class="left-border-for-children" style="width:'100%'">
		
		<div class="form-fieldset-header mt-1">
			<h2>Podatki o stranki</h2>
		</div>
		
		<div class="display-row mt-1 display-row-form" >
            <span>Kontrolna številka</span>
             <kinput disabled type="text" v-model="pridelovalec.kontrolnaStevilka"/>
		</div>
        <div class="display-row mt-1 display-row-form" >
            <span>Prisotna oseba ob kontroli</span>
             <kinput type="text" v-model="kontrola.prisotnaoseba"/>
		</div>
    <div class="display-row mt-1 display-row-form" >
            <span>Lokacija obrata</span>
             <kinput type="text" v-model="kontrola.lokacijaobrata"/>
		</div>
        <div class="display-row mt-1 display-row-form" >
            <span>Vrsta predelave</span>
             <kinput type="text" v-model="kontrola.vrstapredelave"/>
		</div>
		<div class="display-row mt-1 display-row-form" >
            <span>Uporaba zaščitnik znakov</span>
             <kinput type="text" v-model="kontrola.zascitniznaki"/>
		</div>
		
		<div class="form-fieldset-header mt-1">
			<h2>Podatki o kontroli</h2>
		</div>
       
        <div class="display-row mt-1 display-row-form" >
            <span>Kontrolor</span>
            <dropdownlist 
                    :style="{ width: '100%' }"
                    :data-items="kontrolorjiSifrant"
                    :text-field="'naziv'"
                    :value="{...kontrolorjiSifrant.find(i=>i.id==kontrola.kontrolor)}"
                    @change="(e) => kontrolorChange(e, kontrola)"
                      
                   />
		</div>
        <div class="display-row mt-1 display-row-form" >
            <span>Začetek kontrole</span>
             <kendodatetimepicker id="zacetekkontrole"
                       v-model="kontrola.zacetekkontrole"
                       :format="'dd.MM.yyyy HH:mm'">
            </kendodatetimepicker>
        </div>
		<div class="display-row mt-1 display-row-form" >
            <span>Konec kontrole</span>
             <kendodatetimepicker id="koneckontrole"
                       v-model="kontrola.koneckontrole"
                       :format="'dd.MM.yyyy HH:mm'">
            </kendodatetimepicker>
        </div>
        <div>  
            <label for="trajanje" class="display-row mt-1 display-row-form">
            <div class="display-row"><span>Skupaj (ure) </span><kbutton theme-color="secondary" size="small" fill-mode="outline" @click="izracunajtrajanje()">Izračunaj</kbutton></div>
             <input type="text" v-model="kontrola.trajanje" placeholder="hh:mm" name="trajanje" id="trajanje" class="k-textbox" pattern="\d+:[0-5][0,5]"/>
            </label>
        </div>
		<div class="display-row mt-1 display-row-form" >
            <span>Vrsta kontrole</span>
            <dropdownlist
                    :data-items="sifrant['vrstakontrolepridelovalca']"
                    :text-field="'naziv'"
                    @change="(e) => sifranKontrolaChange(e, kontrola)"
                
                    :value="{naziv:kontrola.vrstakontrole,id:sifrant['vrstakontrolepridelovalca'].find(i=>i.naziv==kontrola.vrstakontrole).id}">
                  </dropdownlist>
		</div>

        
        <div class="display-row mt-1 display-row-form" >
            <span>Način kontrole</span>
            <dropdownlist
                    :data-items="sifrant['nacinkontrolepridelovalca']"
                    :text-field="'naziv'"
                    @change="(e) => sifrantNacinChange(e, kontrola)"
                    :style="{ width: '100%' }" 
                    :value="{naziv:kontrola.nacinkontrole,id:sifrant['nacinkontrolepridelovalca'].find(i=>i.naziv==kontrola.nacinkontrole).id}">
                  </dropdownlist>
		</div>

       <div class="display-row mt-1 display-row-form" >
            <span>Drugi prisotni</span>
             <kinput type="text" v-model="kontrola.drugiprisotni"/>
		</div>

        <div class="form-fieldset-header mt-1">
			<h2>3. Kontrolne točke po katalogu nepravilnosti in kršitev</h2>
		</div>

        <table>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2">Skladnost</td>
                
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td>P*</td>
                <td>DA</td>
                <td>NE</td>
            </tr>
        <tr v-for="(kt,index) in kontrolnetocke[shema]" :key="kt.stevilka">
				<td>{{kt.stevilka}}</td>
				<td>{{kt.naziv}}</td>
				<td> <input type="checkbox" v-model="kontrolnetocke[shema][index]['P*']"  class="k-checkbox" /></td>
				<td> <input type="checkbox" v-model="kontrolnetocke[shema][index]['DA']"  class="k-checkbox" /></td>
				<td> <input type="checkbox" v-model="kontrolnetocke[shema][index]['NE']"  class="k-checkbox" /></td>
				
			</tr> 
        </table>
        <div class="display-row mt-1 display-row-form" >
            <span>V obratu je bil odvzet vzorec:</span>
            <input type="checkbox" v-model="kontrola.vzorcenje"  class="k-checkbox" />
		</div>
     
    </div>
		

    <div class="form-fieldset-header mt-1">
			<h2>Ugotovitve:</h2>
		</div>
    <div  >
            <textarea v-model="kontrola.ugotovitve"  rows="10" style="width:100%;"  />
		</div>
		
    <div class="form-fieldset-header mt-1">
			<h2>Pripombe na zapisnik:</h2>
		</div>
    <div  >
            <textarea v-model="kontrola.pripombe"  rows="10" style="width:100%;"  />
		</div>


		
	
</form>
    </div>
    </div>
    </div>
    </div>

</template>

<style scoped>
	.mt-1 {
	margin-top: 1rem !important;
	}

	.display-row{
		display:flex;
		align-items:center;
		gap:1rem;
		
	}
	.display-row-form>*:first-child{
		flex:0 0 25%;
	}
</style>
<script>

import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { DatePicker, DateTimePicker } from '@progress/kendo-vue-dateinputs';
import { Input } from '@progress/kendo-vue-inputs';
import { filterBy } from '@progress/kendo-data-query';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { MultiSelect,DropDownList,ComboBox } from '@progress/kendo-vue-dropdowns';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
//import SifrantKontrolaDownCell from './support/SifrantKontrolaDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
import { authHeader } from '../helpers';
import { Upload } from '@progress/kendo-vue-upload';

import { process } from '@progress/kendo-data-query';
import moment from 'moment'
import { sifrant } from '../store/sifrant.module';
import { kontrolaService } from '../services/kontrola.service';





export default {
  components:{
	'kinput': Input,
	'kbutton': Button,
	'kendo-datepicker': DatePicker,
	'kendodatetimepicker': DateTimePicker,
    'multiselect': MultiSelect,
    'kendo-checkbox': Checkbox,
      'ukaznigumbiknt': StatusCommandCell,
      'ddcell': StatusDownCell,
      'combobox': ComboBox,
      'dropdownlist': DropDownList,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
      'pridelovalec':PridelovalecKratko,
	  upload: Upload,
  },
  props:['sezona','pridelovalecid','shema','kontrolaid'],
    data () {
        return {
			ipobsegcertificiranjafilter:{},
			ip:{},
            kontrola:{
				podrocjecertificiranja:"",
				status:"",
				stkontrole:0,
				datumnadzora:new Date(),
				vrstakontrole:"",
				lokacijakontrole:"",
				zacetekkontrole:new Date(),
				koneckontrole:new Date(),
				trajanje:0,
				vzorcenje:true,
				vzorci:[],
				prisotneosebe:[],
				seznam:[],
				storitvepodizvajalca:[],
				podizvajalci:[{naziv:"",naslov:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				storitvepodizvajalca:[{naziv:"",dejavnost:"",datumzadnjeaktivnosti:new Date(),edit:true}],
				neskladnosti:"",
				posebnosti:"",
				ponovna:"",
				zuppripombe:false,
				zuppripomba:"",
				zupposlannaemail:"", //email iz podatkov
				zupprevzetnasedezu:"",
				zupprevzetobkontroli:"",
				zakljuceno:"",
				izvajalcikontrole:[{naziv:"",datum:new Date(),edit:true}],
				priloge:[{nazivpriloge:"",imepriloge:"",edit:true}]
			},
			files:[],
			kontrolorji:[],
			sifrantTree:{},
            dataLoading:false,
			podrocjacertificiranja:[{"naziv":"IPS","id":1, "prikaz":"IPSO"},{"naziv":"IPG","id":2, "prikaz":"IPG"},{"naziv":"IPP","id":3, "prikaz":"IPP"},{"naziv":"IPZ","id":4, "prikaz":"IPZ"},{"naziv":"IPH","id":5, "prikaz":"IPH"}],
            kontrolnetocke:{
              "EKO PRI":
            [
 {
   "stevilka": 1,
   "naziv": "Pravila pridelave rastlin"
 },
 {
   "stevilka": 2,
   "naziv": "Pravila za specifične rastline in rastlinske proizvode (gobe, samonikle rastline) "
 },
 {
   "stevilka": 3,
   "naziv": "Pravila za živinorejo"
 },
 {
   "stevilka": 4,
   "naziv": "Čebelarjenje"
 },
 {
   "stevilka": 5,
   "naziv": "Pravila za pridelavo predelane hrane"
 },
 {
   "stevilka": 6,
   "naziv": "Pravila za pridelavo predelane krme"
 },
 {
   "stevilka": 7,
   "naziv": "Vino / kvas"
 },
 {
   "stevilka": 8,
   "naziv": "Zbiranje, pakiranje, prevoz, skladiščenje, označevanje proizvodov"
 },
 {
   "stevilka": 9,
   "naziv": "Vzporedna ekološka in neekološka pridelava"
 },
 {
   "stevilka": 10,
   "naziv": "Odprava neskladij od prejšnje kontrole"
 },
 {
   "stevilka": 11,
   "naziv": "Evidentiranje vseh pritožb"
 },
 {
   "stevilka": 12,
   "naziv": "Uporaba zaščitnih znakov"
 },
 {
   "stevilka": 13,
   "naziv": "Nadzor nad uporabo certifikata"
 },
 {
   "stevilka": 14,
   "naziv": "Preverjanje preventivnih in previdnostnih ukrepov"
 }
],
"EKO PRE":
[
  { "stevilka": 1, "naziv": "Splošna pravila za predelavo" },
  { "stevilka": 2, "naziv": "Zbiranje, pakiranje, prevoz in skladiščenje" },
  { "stevilka": 3, "naziv": "Dokumentacija in recepture" },
  { "stevilka": 4, "naziv": "Vino, kvas" },
  { "stevilka": 5, "naziv": "Označevanje" },
  { "stevilka": 6, "naziv": "Proizvodnja krme in označevanje" },
  { "stevilka": 7, "naziv": "Drugi proizvodi" },
  { "stevilka": 8, "naziv": "Uvoz / izvoz iz tretjih dežel" },
  { "stevilka": 9, "naziv": "Odprava neskladij od prejšnje kontrole" },
  { "stevilka": 10, "naziv": "Evidentiranje vseh pritožb" },
  { "stevilka": 11, "naziv": "Uporaba zaščitnih znakov" },
  { "stevilka": 12, "naziv": "Nadzor nad uporabo certifikata" },
  { "stevilka": 13, "naziv": "Preverjanje preventivnih in previdnostih ukrepov" }
]}
,
			 podatkiGlave: [{
  sifra:"IPS",
  naslov:"Kontrolne točke IPSO (Ta priloga je sestavni del zapisnika)",
  podrocje:"Integrirana pridelava sadja in oljk (IPSO)",
  predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprememb. in dop.)",
  pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
  obrazec:"E_Obr. 4.52, rev. 09",
  },
  {
  sifra:"IPP",
  naslov:"Kontrolne točke IPP (Ta priloga je sestavni del zapisnika)",
  podrocje:"Integrirana pridelava poljščin (IPP)",
  predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprememb. in dop.)",
  pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
  obrazec:"E_Obr. 4.53, rev. 08",
  },
  {
  sifra:"IPZ",
  naslov:"Kontrolne točke IPZ (Ta priloga je sestavni del zapisnika)",
  podrocje:"Integrirana pridelava zelenjave (IPZ)",
  predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprememb. in dop.)",
  pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
  obrazec:"E_Obr. 4.54, rev. 08",
  },
  {
  sifra:"IPG",
  naslov:"Kontrolne točke IPG (Ta priloga je sestavni del zapisnika)",
  podrocje:"Integrirana pridelava grozdja (IPG)",
  predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprememb. in dop.)",
  pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
  obrazec:"E_Obr. 4.55, rev. 08",
  },
  {
  sifra:"IPH",
  naslov:"Kontrolne točke IPH (Ta priloga je sestavni del zapisnika)",
  podrocje:"Integrirana pridelava hmelja (IPH)",
  predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023 s sprememb. in dop.)",
  pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
  obrazec:"E_Obr. 4.56, rev. 08",
  },
  ],
  /*
			podatkiGlave:[{
sifra:"IPS",
naslov:"Kontrolne točke IPSO",
podrocje:"Integrirana pridelava sadja in oljk (IPSO)",
predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023)",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.52, rev. 08, 12.4.2023",
},
{
sifra:"IPP",
naslov:"Kontrolne točke IPP",
podrocje:"Integrirana pridelava poljščin (IPP)",
predpis:"Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023)",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.53, rev. 07, 07.4.2023",
},
{
sifra:"IPZ",
naslov:"Kontrolne točke IPZ",
podrocje:"Integrirana pridelava zelenjave (IPZ)",
predpis:"Predpis	Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023)",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.54, rev. 07, 12.4.2023",
},
{
sifra:"IPG",
naslov:"Kontrolne točke IPG",
podrocje:"Integrirana pridelava grozdja (IPG)",
predpis:"Predpis	Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023)",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.55, rev. 07, 18.4.2023",
},
{
sifra:"IPH",
naslov:"Kontrolne točke IPH",
podrocje:"Področje	Integrirana pridelava hmelja (IPH)",
predpis:"Predpis	Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur. l. RS 31/2023)",
pravila:"Pravila postopka certificiranja v svoji veljavni reviziji (1.80doc)",
obrazec:"E_Obr. 4.56, rev. 07, 18.4.2023",
},
],*/
           statusnadzora:[
			{id:1,naziv:"nova"},
			{id:2,naziv:"v teku"},
			{id:3,naziv:"odločitev"},
			{id:4,naziv:"konec"},
			{id:5,naziv:"prekoračen rok, neskladja niso odpravljena"},
			
		   ],
		   statusprisotnihoseb:[
			{id:1,naziv:"izvajalec"},
			{id:2,naziv:"pooblaščenec"},
			{id:3,naziv:"ostali prisotni"},
			
		   ],
            dataSezona:this.sezona,
          
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' } 
            ],
            columns: [

               { field: "zaporednastevilka", title:"ID nadzora",width: "100px",filterable:false,footerCell:this.nogaNazivVsot,type:"number",editable:false},
			   { field: "statusnadzora", title:"Status nazdora",width: "150px"},
			   { field: "shema", title:"shema"},
			   { field: "podrocje", title:"podrocje"},
			   { field: "izvajalec", title:"izvajalec"},
			   { field: "naslov", title:"naslov"},
			   { field: "datumkontrole", filterable:false, title:"Datum kontrole",width: "150px", type:"date",editor:"date",format:"{0:d}"},
               { field: "trajanje", title:"Trajanje (h)",width: "80px",filterable:false,type:"number",editor:"numeric",format:"{0:n2}"},
            
			   { field: "vrstakontrole", title:"Vrsta kontrole",width: "150px"},
			   { field: "kontrolor", cell:"kontrolor", title:"Kontrolor",width: "240px"},
               { field: "mnenjekontrolorja", title:"Mnenje",width: "90px"},
             
			   { field: "tveganje", title:"Ocena tveganja"},
			   { field: "cena", title:"cena"},
			   { field: "statusplacila", title:"Status plačila"},
			 
                //{ field: "vzorci", title:"Vzorci",width: "100px"},
                //{ field: "posebnosti", title:"Posebnosti",width: "100px"},
                //{ field: "priloge", title:"Priloge",width: "100px"},
                //{ field: "sifrakontrolorja", title:"Kontrolor",width: "100px"},
              /*   { field: "kolicina", title:"Količina",width: "100px",filterable:false,type: "number",footerCell: this.nogaVsotaKolicina,width: "150px",format: '{0:n2}'},
                { field: "merskaenotanaziv", title:"Enota",width: "100px",filterable:false},
                //{ field: "enota", title:"Enota", type:"string",filterable:false,width: "80px"},
                { field: "veljavnostcertifikataod", filterable:false, title:"Datum določitve statusa",width: "170px", cell:this.formatDate},
                //template: "#= kendo.toString(kendo.parseDate(veljavnostcertifikataod, 'yyyy-MM-dd'), 'MM/dd/yyyy') #"},
                //filter:'date',format: "{0:d}"},
               // { field: "veljavnostcertifikatado", title:"Veljavnost statusa", type:"string",editor: 'date',width: "150px",format: '{0:d}'},

                { field: "statuspridelkanaziv", title:"Status",width: "150px"},
                */
                { cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
            ],
          

           

        }
    },
      computed: {
		saveurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/dodaj`
			}
		},
		removeurl:{
            get(){
				return `${Vue.prototype.$config.apiUrl}/datoteke/brisi`
			}
		},
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },

        ...mapState({gridData(state) {
          return state.kontrola.kontrola;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
        kontrolorjiSifrant(){
          return this.kontrolorji.map(i=>{
                i.naziv=i.priimek+' '+i.ime;
                return i;            
          })
        }
      
           },
	 beforeRouteLeave (to, from, next) {
  	if (this.confirmStayInDirtyForm()){
	    next(false)
  	} else {
	    // Navigate to next view
	    next()
  	}
},
beforeDestroy() {
  window.removeEventListener('beforeunload', this.beforeWindowUnload)
},
    created () {
		window.addEventListener('beforeunload', this.beforeWindowUnload)
 if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};
		
	  this.naloziPodatke();

      
    },
  


    methods: {
		confirmLeave() {
    return window.confirm('Zapuščate stran. Ali ste shranili vse spremembe?')
  },

  confirmStayInDirtyForm() {
	//tukaj lahko preverim, če se je kaj spremnijalo...
    return !this.confirmLeave()
  },

  beforeWindowUnload(e) {
    if (this.confirmStayInDirtyForm()) {
      // Cancel the event
      e.preventDefault()
      // Chrome requires returnValue to be set
      e.returnValue = ''
    }   
  },
      ...mapActions('pridelava', ['loadIdPoSezoni','loadOne','save']),
        ...mapActions('kontrola', ['load','loadPreteklaSezona']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('kontrola',['update',"add","remove","makeEditable",'replace']),
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
             nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Vsota:']);
        },
        //gvž in število
        nogaVsotaStevila: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.stevilo?current.stevilo:0):0, 0),"n0")]);
        },
        nogaVsotaGvz: function (h, emptyElement , props, listeners ) {
          if(this.gridData)
            return h('span', {}, [kendo.toString(this.gridData.reduce((acc, current) => acc+=current.jeaktivna?(current.vsotagvz?current.vsotagvz:0):0, 0),"n3")]);
        },
        formatDate: function (h, emptyElement , props, listeners ) {
            if(props.dataItem.inEdit)
              return emptyElement
            else
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
		izracunajtrajanje(){
			//var diff =(this.kontrola.zacetekkontrole.getTime() - this.kontrola.koneckontrole.getTime()) / 1000;
			var duration = moment.duration(moment(this.kontrola.koneckontrole).diff(this.kontrola.zacetekkontrole));
  			//let minutes =diff/60;
			//let hours=minutes/60;
			//let lefminutes=minutes%60
			//Math.abs(Math.ceil(diff))
  			Vue.set(this.kontrola,"trajanje",Math.floor(duration.as('h'))+moment.utc(Math.round(duration.as('ms')/(1000*5*60))*1000*5*60).format(':mm'));
			
		},
		dodajvzorcenje(){
            if(!this?.kontrola?.vzorci)
                this.kontrola.vzorci=[];

            const newRecord = { 
				id:0,
				datumvzorcenja:new Date(),
				datumizvida:new Date(),
				idporocila:0,
				datumpregleda:new Date,
				pregledizvedel:"",
				skladno:true,
				opomba:'',
				edit:true};

				this.kontrola.vzorci.push(newRecord);
        }   ,
        removevzorcenje(e){
        
                var index=this.kontrola.vzorci.indexOf(e);
                if(index>=0)
                        this.kontrola.vzorci.splice(index,1)

        },
        vzorcenjechange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajprisotneosebe(){
            if(!this?.kontrola?.prisotneosebe)
                this.kontrola.prisotneosebe=[];

            const newRecord = { 
				ime:"",
				podjetjekmg:"",
				funkcija:"",
				status:"",
				edit:true};

				this.kontrola.prisotneosebe.push(newRecord);
        }   ,
        removeprisotneosebe(e){
        
                var index=this.kontrola.prisotneosebe.indexOf(e);
                if(index>=0)
                        this.kontrola.prisotneosebe.splice(index,1)

        },
        prisotneosebechange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		dodajpodizvajalci(){
            if(!this?.kontrola?.podizvajalci)
                this.kontrola.podizvajalci=[];

            const newRecord = { 
				naziv:"",
				naslov:"",
				dejavnost:"",
				datumzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.podizvajalci.push(newRecord);
        }   ,
        removepodizvajalci(e){
        
                var index=this.kontrola.podizvajalci.indexOf(e);
                if(index>=0)
                        this.kontrola.podizvajalci.splice(index,1)

        },
        podizvajalcichange: function (e) {
            e.dataItem[e.field]=e.value;
		},

		dodajpriloge(){
            if(!this?.kontrola?.priloge) //dodaj privzete vrednosti
                this.kontrola.priloge=[]; 

            const newRecord = { 
				imepriloge:"",
				nazivpriloge:"",
				edit:true};

				this.kontrola.priloge.push(newRecord);
        }   ,
        removepriloge(e){
        
                var index=this.kontrola.priloge.indexOf(e);
                if(index>=0)
                        this.kontrola.priloge.splice(index,1)

        },
        prilogechange: function (e) {
            e.dataItem[e.field]=e.value;
		},

		dodajstoritvepodizvajalca(){
            if(!this?.kontrola?.storitvepodizvajalca)
                this.kontrola.storitvepodizvajalca=[];

            const newRecord = { 
				naziv:"",
				dejavnost:"",
				datunzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.storitvepodizvajalca.push(newRecord);
        }   ,
        removestoritvepodizvajalca(e){
        
                var index=this.kontrola.storitvepodizvajalca.indexOf(e);
                if(index>=0)
                        this.kontrola.storitvepodizvajalca.splice(index,1)

        },
        storitvepodizvajalcachange: function (e) {
            e.dataItem[e.field]=e.value;
		},
		
		dodajizvajalcikontrole(){
            if(!this?.kontrola?.izvajalcikontrole)
                this.kontrola.izvajalcikontrole=[];

            const newRecord = { 
				naziv:"",
				dejavnost:"",
				datunzadnjeaktivnosti:new Date(),
				edit:true};

				this.kontrola.izvajalcikontrole.push(newRecord);
        }   ,
        removeizvajalcikontrole(e){
        
                var index=this.kontrola.izvajalcikontrole.indexOf(e);
                if(index>=0)
                        this.kontrola.izvajalcikontrole.splice(index,1)

        },
        izvajalcikontrolechange: function (e) {
            e.dataItem[e.field]=e.value;
		},

		authorize(event) {
			event.headers=authHeader();
		},
		onAdd(event) {
		
        this.files=event.newState;
      },
      onRemove(event) {
        this.files=event.newState;
      },
      onProgress(event) {
		console.log("progres");
		console.log(event);
		this.files=event.newState;
      },
      onStatusChange(event) {
		
		console.log("done");
		console.log(event)
		this.files=event.newState;
		Vue.set(this.kontrola,'seznam',{datotekaid:event.response?.response?._id,files:this.files});
      },

		saveData(e){
          //this.save( this.dataSezona);
        },
		handleSubmit(e){

		e.preventDefault();
		},
		onFilterChange(event,podshema) {
			console.log(podshema)
            
			Vue.set(this.ipobsegcertificiranjafilter,podshema,filterBy(this.ipobsegcertificiranja.filter(i=>i.področje==podshema).slice(), event.filter))
			console.log(this.ipobsegcertificiranjafilter[podshema])
        },
            //error handle za prazen šifrnat!!!!
        naloziPodatke: function(){
          this.dataLoading=true;
		 let sezona=this.dataSezona.sezona;
		 let shema=this.shema;
		 let pridelovalecid=this.pridelovalecid;
		 let thisComp=this;
		 var sifranti=[
		  this.naloziSifrant({sezona:sezona,sifrant:"kontrolorjieko"}).then(

		  	data=>{
				this.kontrolorji=this.sifrant["kontrolorjieko"];
			},
  			error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
			
			),
            this.naloziSifrant({sezona:sezona,sifrant:"vrstakontrolepridelovalca"}).then(

		  	data=>{
				//this.kontrolorji=this.sifrant["vrstakvrstakontrolepridelovalcaontrole"];
			},
  			error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
			
			),
            this.naloziSifrant({sezona:sezona,sifrant:"nacinkontrolepridelovalca"}).then(

		  	data=>{
				//this.kontrolorji=this.sifrant["nacinkontrolepridelovalca"];
			},
  			error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
			
			),
			//mogoče filter po vrsti
		];
		
		Promise.all(sifranti).then(()=>{
			console.log("Šifranti naloženi")
        

          
		this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{

			console.log("Grem po stranko")
			
			let kontaktkmg=p.kontakt.find(k=>k.vloga=="kmetija (kmg)")
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt.find(k=>k.glavni)
                if(!kontaktkmg)
                    kontaktkmg=p.kontakt[0];

			let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
		if(!pridelava){
			//javi napako, ne dodaj podatkov
			console.log("resne težave, če ni sheme")
			return;
		}
		//naloži kontrolo, če je id, če ni, napaka...
		this.pridelovalec.kontrolnaStevilka=pridelava.kontrolnaStevilka;
		let novaprijava={
		obseg:{},
		seznam:{datotekaid:null,files:[]},
		datumseznama:(new Date()).toISOString()};

		

		kontrolaService.loadOne(sezona,pridelovalecid,shema,this.kontrolaid).then(
			data=>{

				
				var datumi=["datumkontrole","datumnadzora","zacetekkontrole","koneckontrole","datumnajave","pripravazapisnika","odobritevzapisnika","pricetekveljave"]
				//vzorci datum pregleda
				//datumzadnjeaktivnosti podizvajalci in stortivepodizvajalca
				//izvajalcikontrole datum
				
				//kontrolor v kontrolorji
			
				for (let d of datumi){
					if(data[d])
						data[d]=provideIntlService(thisComp).parseDate( data[d]);
				}

				console.log(data);
				data.lokacijakontrolenaslov=data.lokacijakontrolenaslov?data.lokacijakontrolenaslov:kontaktkmg.naslov;
				data.lokacijakontroleposta=data.lokacijakontroleposta?data.lokacijakontroleposta:kontaktkmg.posta;
				data.lokacijakontrolepostnastevilka=data.lokacijakontrolepostnastevilka?data.lokacijakontrolepostnastevilka:kontaktkmg.postnastevilka;
				
				if(data.kontrolnetocke&&data.kontrolnetocke.length>0)
                    this.kontrolnetocke[shema]=data.kontrolnetocke;
				Vue.set(thisComp,'kontrola',data);

				
				

			},
			err=>{}
		);

		

	  

		});

	});
          
        
      
        },
        sifranKontrolaChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["vrstakontroleid"])
              dataItem.oldValues["vrstakontroleid"] =dataItem["vrstakontroleid"];

            if(!dataItem.oldValues["vrstakontrole"])
              dataItem.oldValues["vrstakontrole"] =dataItem["vrstakontrole"];



            Vue.set( dataItem, 'vrstakontrole',e.value.naziv);
              Vue.set( dataItem, 'vrstakontroleid',e.value.id);
            
    
        },
        sifrantNacinChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


           
            if(!dataItem.oldValues["nacinkontrole"])
              dataItem.oldValues["nacinkontrole"] =dataItem["nacinkontrole"];



      
              Vue.set( dataItem, 'nacinkontrole',e.value.naziv);
            
    
        },
          sifranMnenjeChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            
            if(!dataItem.oldValues["mnenjekontrolorja"])
              dataItem.oldValues["mnenjekontrolorja"] =dataItem["mnenjekontrolorja"];

            Vue.set( dataItem, 'mnenjekontrolorja',e.value.naziv);
            
            
    
        },
        sifranMestoChange: function(e,dataItem) {

          
if(!dataItem.oldValues)
dataItem.oldValues={}



if(!dataItem.oldValues["mestokontrole"])
dataItem.oldValues["mestokontrole"] =dataItem["mestokontrole"];

Vue.set( dataItem, 'mestokontrole',e.value.naziv);



},

        kontrolorChange: function(e,dataItem) {

          
               if(!dataItem.oldValues)
              dataItem.oldValues={}


            if(!dataItem.oldValues["kontrolorid"])
              dataItem.oldValues["kontrolor"] =dataItem["kontrolor"];

         
            Vue.set( dataItem, 'kontrolor',e.value.id);
            this.test=e.value.id
         
    
        },
        itemChange: function (e) {
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          Vue.set( e.dataItem, e.field,e.value);

        //  if(e.field=="stevilo")
          //    Vue.set( e.dataItem, 'vsotagvz',(e.value?e.value:0)*this.sifrant['proizvod'].find(s=>s.id==e.dataItem.proizvodid).gvz);              
           
        },
        dodajIzPrejsnjeSezone(){
            this.loadPreteklaSezona({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled});

        },

        //default vrednosti
         vstavi() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  zaporednastevilka:this.gridData.reduce((a,c)=>{return c.zaporednastevilka>a?c.zaporednastevilka:a},0)+1,
                  datumkontrole:new Date(),
                  vrstakontroleid:this.sifrant["vrstakontrolepridelovalca"][0].id,
                  vrstakontrole:this.sifrant["vrstakontrolepridelovalca"][0].naziv,
                  nacinkontrole:this.sifrant["nacinkontrolepridelovalca"][0].naziv,
                  mestokontrole:this.sifrant["mestokontrolepridelovalca"][0].naziv,
                  //mestokontrole:"",
                  mnenjekontrolorjaid:this.sifrant["mnenjekontrolorja"][0].id,
                  mnenjekontrolorja:this.sifrant["mnenjekontrolorja"][0].naziv
                   };
            this.add(dataItem);
        },
        edit: function (e) {
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = 1;
            
            this.update(e.dataItem);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
               Vue.set( dataItem, value,dataItem.oldValues[value]);
            }
             Vue.set( dataItem, jeaktivna,0);
             Vue.set( dataItem, jeaktivna,1);
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
            this.update(e.dataItem);
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            e.dataItem.jeaktivna=e.dataItem.jeaktivna?0:1;
            this.update(e.dataItem);

        },
        //tu je treba dodat še shemo...
       sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'kontrolaip', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalec._id,kontrolaid:this.kontrolaid,podshema:this.kontrola.podrocjecertificiranja}} );
             //this.pridelovalec.sezona=this.sezona;
             this.naloziPodatke();
             // });



        },
		izdelajZapisnik(){
			let route = this.$router.resolve({ name: 'zapisnikeko', params: {sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalec._id,kontrolaid:this.kontrolaid,shema:this.shema} });

			window.open(route.href, '_blank');
			
		},
/*
             @datastatechange="dataStateChange"
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
            this.dataResult = process(this.gerk, {});

        },
  */    
        async shraniKontrole () {
			//kaj narediš s seznamom in obsegom.... vprašaj...
			//this.save( this.dataSezona);
			
            this.kontrola.kontrolnetocke=this.kontrolnetocke[this.shema];
            this.kontrola.neskladja=this.kontrolnetocke[this.shema].filter(kt=>kt["NE"]==true);

			await kontrolaService.saveOne(this.kontrola,this.sezona,this.pridelovalecid,this.shema,this.kontrolaid)
			
			//shrani obseg...

              //this.save();
    },
       
        
    }
};
</script>

